import { render } from "./TrainingProgramUpdateForm.vue?vue&type=template&id=5b8c5ad3"
import script from "./TrainingProgramUpdateForm.vue?vue&type=script&lang=js"
export * from "./TrainingProgramUpdateForm.vue?vue&type=script&lang=js"

import exportComponent from "/home/misha/Рабочий стол/kolos-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__